import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import {
  IconButton,
  InputAdornment,
  Modal,
  TextField,
  Typography,
} from '@material-ui/core';
import { Search } from '@material-ui/icons';
import selectTableHOC from 'react-table/lib/hoc/selectTable';
import ReactTable from 'react-table';
// React-table library requires to import css as well:
import 'react-table/react-table.css'; // eslint-disable-next-line
import ActionButton from '../../../components/ActionButton';
import {
  getCountEserciziCommercialiForReplica,
  getEserciziCommercialiFilteredForReplica,
} from '../../../utils/api/esercizi_commerciali_api';
import {
  getConsulenteId,
  getGruppoId,
  isLoggedUserAConsulente,
} from '../../../utils/storage';
import { getRolloutStatusBatch } from '../../../utils/api/rollout_status_api';
import { reportApiError } from '../../../utils/reportApiError';

const styles = (theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(4),
    textAlign: 'center',
    backgroundColor: 'white',
    color: 'black',
    padding: theme.spacing(3),
    borderRadius: '6px',
    boxShadow: theme.shadows[6],
    overflowY: 'auto',
    width: '90%',
    maxWidth: '960px',
    maxHeight: '90vh',
  },
  tableWrapper: {
    width: '90%',
  },
  buttonWrapper: {
    width: '90%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

const SelectTable = selectTableHOC(ReactTable);

class ModalSelezioneEserciziCommerciali extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      colonneEsercizi: [],
      selectedEsercizi: [], // multiselect
      loadedPage: 0,
      totalPages: 1,
      loading: false,
      esercizi: [],
      emailFilter: '',
      nameFilter: '',
      consulenteId: null,
      gruppoId: null,
    };
  }

  componentDidMount() {
    let consulenteId = isLoggedUserAConsulente()
      ? Number.parseInt(getConsulenteId(), 10)
      : null;

    let gruppoId =
      getGruppoId() === null || getGruppoId() === 'null'
        ? null
        : Number.parseInt(getGruppoId(), 10);
    // console.log("Gruppo ID:", gruppoId);
    // console.log("Consulente ID:", consulenteId);
    this.setState(
      {
        consulenteId,
        gruppoId,
      },
      () => {
        // Fetch data only if gruppoId is set
        if (this.props.gruppoId != null) {
          this.onFetchData({ page: 0, pageSize: 10 });
        }
      },
    );
  }

  getEserciziColumn = () => {
    return [
      {
        Header: 'Id',
        id: 'IdEsercizio',
        filterable: false,
        accessor: (data) => data.id,
      },
      {
        Header: 'Email',
        id: 'EmailEsercizio',
        accessor: (data) => data.emailGestore,
        minWidth: 210,
        Filter: (cellInfo) => (
          <TextField
            value={this.state.emailFilter}
            onChange={(event) => {
              this.setState({
                emailFilter: event.target.value,
              });
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => {
                      this.setState({ loadedPage: 0 }, () =>
                        this.onFetchData({ page: 0, pageSize: 10 }),
                      );
                    }}
                    size="small"
                  >
                    <Search />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        ),
      },
      {
        Header: 'Nome',
        id: 'NomeEsercizio',
        minWidth: 210,
        Filter: (cellInfo) => (
          <TextField
            value={this.state.nameFilter}
            onChange={(event) => {
              this.setState({
                nameFilter: event.target.value,
              });
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => {
                      this.setState({ loadedPage: 0 }, () =>
                        this.onFetchData({ page: 0, pageSize: 10 }),
                      );
                    }}
                  >
                    <Search />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        ),
        accessor: (data) => data.nome,
      },
    ];
  };

  toggleSelection = (key, shift, row) => {
    const selectedId = parseInt(key.split('select-')[1], 10);
    this.setState((prevState) => {
      const alreadySelected = prevState.selectedEsercizi.includes(selectedId);
      let newSelected;
      if (alreadySelected) {
        newSelected = prevState.selectedEsercizi.filter(
          (id) => id !== selectedId,
        );
      } else {
        newSelected = [...prevState.selectedEsercizi, selectedId];
      }
      return { selectedEsercizi: newSelected };
    });
  };

  toggleAll = () => {
    const isSelected =
      this.state.selectedEsercizi.length === this.state.esercizi.length;
    if (isSelected) {
      this.setState({ selectedEsercizi: [] });
    } else {
      const allIds = this.state.esercizi.map((esercizio) => esercizio.id);
      this.setState({ selectedEsercizi: allIds });
    }
  };

  isSelected = (key) => {
    const id = parseInt(key, 10);
    return this.state.selectedEsercizi.includes(id);
  };

  onFetchData = (state) => {
    this.setState({ loading: true });
    // console.log(this.state);
    // Fetch the count of esercizi commerciali based on filters
    const { emailFilter, nameFilter } = this.state;

    getCountEserciziCommercialiForReplica(
      this.state.gruppoId,
      this.state.consulenteId,
      emailFilter,
      nameFilter,
      null,
      null,
      null,
      null,
      null,
      true,
    )
      .then((count) => {
        if (count === null || count === undefined) {
          count = 1; // Default to 1 if count is null or undefined
        }
        if (count > 1) {
          count = count - 1; // Ensure count is a number
        }
        const totalPages = Math.ceil(count / state.pageSize);
        this.setState({ totalPages });
        const { esercizioId } = this.props;

        return getEserciziCommercialiFilteredForReplica(
          this.state.gruppoId,
          this.state.consulenteId,
          null,
          state.page,
          state.pageSize,
          'id',
          emailFilter,
          nameFilter,
          null,
          null,
          null,
          null,
          null,
          true,
          esercizioId,
        );
      })
      .then((response) => {
        // Filtra come prima
        const filteredResult = response.filter(
          (esercizio) => esercizio.gestioneOperativaSeparata,
        );
        // Chiamata alla nuova API per lo stato rollout
        const ids = filteredResult.map((e) => e.id);
        return getRolloutStatusBatch(ids, 'GESTIONE_OPERATIVA')
          .then((rolloutRes) => {
            // Mostra solo quelli con open: true
            const openIds = rolloutRes.list
              .filter((item) => item.open)
              .map((item) => item.idEsercizio);
            const finalList = filteredResult.filter((e) =>
              openIds.includes(e.id),
            );
            this.setState({
              esercizi: finalList,
              colonneEsercizi: this.getEserciziColumn(),
              loading: false,
              loadedPage: state.page,
            });
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        reportApiError(error);
        this.setState({ loading: false });
      });
  };

  render() {
    const { classes } = this.props;

    return (
      <Modal
        open={this.props.open}
        onClose={this.props.onClose}
        className={classes.modal}
      >
        <div className={classes.modalContainer}>
          <Typography variant="h5">
            Selezionare l'esercizio su cui replicare la gestione operativa
          </Typography>
          <div className={classes.tableWrapper}>
            <SelectTable
              toggleSelection={this.toggleSelection}
              toggleAll={this.toggleAll}
              isSelected={this.isSelected}
              keyField={'id'}
              filterable={true}
              resizable={true}
              selectAll={
                this.state.selectedEsercizi.length ===
                this.state.esercizi.length
              }
              showPageSizeOptions={false}
              showPageJump={false}
              showPaginationBottom={true}
              defaultPageSize={10}
              loading={this.state.loading}
              loadingText="Caricamento..."
              page={this.state.loadedPage}
              pages={this.state.totalPages}
              onPageChange={(pageIndex) => {
                this.setState({ loadedPage: pageIndex }, () => {
                  this.onFetchData({ page: pageIndex, pageSize: 10 });
                });
              }}
              manual
              onFetchData={(state) => this.onFetchData(state)}
              columns={this.state.colonneEsercizi}
              data={this.state.esercizi}
              previousText="Precedente"
              nextText="Successivo"
              noDataText="Nessun esercizio trovato"
              pageText="Pagina"
              ofText="di"
              rowsText="righe"
              pageJumpText="Vai a pagina"
              rowsSelectorText="righe per pagina"
            />
          </div>
          <div className={classes.buttonWrapper}>
            <ActionButton
              onClick={this.props.onClose}
              label="Annulla"
              secondaryButton
              disabled={false}
              grayVersion={false}
            />
            <ActionButton
              label="Conferma"
              disabled={false}
              grayVersion={false}
              onClick={() => {
                if (this.state.selectedEsercizi.length > 0) {
                  this.props.openSubmit(this.state.selectedEsercizi);
                } else {
                  alert(
                    'Attenzione, occorre selezionare almeno un esercizio commerciale',
                  );
                }
              }}
            />
          </div>
        </div>
      </Modal>
    );
  }
}

ModalSelezioneEserciziCommerciali.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  gestioneOperativaSeparata: PropTypes.number.isRequired,
  esercizioId: PropTypes.number, // Optional, used to pass the current
};

export default withStyles(styles)(ModalSelezioneEserciziCommerciali);
